module.exports = __webpack_public_path__ + "img/thumb_37.1f0a7d05.jpg";